module.exports = __webpack_public_path__ + "img/specific_users.221d1926.svg";